import * as React from 'react'
import { ITripHistoryObject } from '../../types'
import TripHistoryDetailSection from './TripHistoryDetailSection'
import TripWaitingForPickup from './trip-detail/TripWaitingForPickup'
import * as moment from 'moment'

interface ITripHistoryMetaDetailsProps {
  trip: ITripHistoryObject
}

const TripHistoryMetaDetails = (props: ITripHistoryMetaDetailsProps) => {
  const trip = props.trip
  return (
    <TripHistoryDetailSection title='Trip Details'>
      <div className='flex h6 mb02 font-grey'>
        <div className='col-6'>Rider</div>
        <div className='col-6 right-align'>{trip.riderCount}</div>
      </div>
      <div className='flex h6 mb02 font-grey'>
        <div className='col-6'>Wheelchair</div>
        <div className='col-6 right-align'>{trip.wheelchair}</div>
      </div>
      <div className='flex h6 mb02 font-grey'>
        <div className='col-6'>Attendant</div>
        <div className='col-6 right-align'>{trip.attendant ? 'Yes' : 'No'}</div>
      </div>
      <div className='flex h6 mb02 font-grey'>
        <div className='col-6'>Leaving Time</div>
        <div className='col-6 right-align'>{moment(trip.leavingTime).format('hh:mm A')}</div>
      </div>
      <div className='flex h6 mb02 font-grey'>
        <div className='col-6'>Assistance</div>
        <div className='col-6 right-align'>{trip.assistance}</div>
      </div>
      <div className='flex mb02'>
        <div className='col-6 font-grey'>cost ${trip.cost}</div>
        <div className='col-6 right-align'>fare ${trip.fare}</div>
      </div>
    </TripHistoryDetailSection>
  )
}

export default TripHistoryMetaDetails



// WEBPACK FOOTER //
// ./src/components/trips/TripHistoryMetaDetails.tsx